import { FC } from 'react';

import { useContextSelector } from 'use-context-selector';

import { Button, ButtonProps } from '../../Button';
import { DetailsContext } from '../Details.context';

type DetailsToggleProps = Omit<ButtonProps, 'onClick'>;

export const DetailsToggle: FC<DetailsToggleProps> = ({
  children,
  ...props
}) => {
  const open = useContextSelector(DetailsContext, ({ open }) => open);

  return (
    <Button {...props} onClick={open}>
      {children}
    </Button>
  );
};
